var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('jd-form',{ref:"orderDetailRef",staticClass:"mb16",attrs:{"form-info":_vm.inputGoodsDetail,"btn30":true},on:{"search":_vm.searchOrderDetail}}),_c('div',{staticClass:"mb16 flex-end"},[_c('jd-button',{attrs:{"type":"text"},on:{"click":_vm.exportAll}},[_vm._v("导出")])],1),_c('jd-table',{attrs:{"loading":_vm.loading,"tableInfo":_vm.tableInfo,"isIndex":true,"tableData":_vm.orderDetailData,"pageInfo":{
      pageNum: _vm.goodsDetailPage.current,
      pageSize: _vm.goodsDetailPage.size,
      total: _vm.total,
    }},on:{"sort-change":_vm.sortChange,"handlePage":(val) => {
        (this.goodsDetailPage.current = val.pageNum),
          (this.goodsDetailPage.size = val.pageSize);
          _vm.getList();
      }}}),(_vm.openRemarkDialog)?_c('generate',{attrs:{"control":_vm.openRemarkDialog},on:{"transData":(val) => (_vm.openRemarkDialog = val),"transData1":_vm.confirmExport}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }